import { configureStore } from '@reduxjs/toolkit'
import commonReducer from './common'
import loginReducer from './login'
import subscriptionReducer from './subscription'
import userReducer from './user'
import storeReducer from './store'
import productReducer from './product'
import planReducer from './plan'
import paymentsReducer from './payment'
import requestReducer from './request'
import trackReducer from './track'

const store = configureStore({
  reducer: {
    common: commonReducer,
    login: loginReducer,
    subscription: subscriptionReducer,
    user: userReducer,
    store: storeReducer,
    plan: planReducer,
    product: productReducer,
    payment: paymentsReducer,
    request: requestReducer,
    track: trackReducer,
  },
})

export default store
